import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorkerRegistration'
import 'antd/dist/antd.css';
import 'keen-slider/keen-slider.min.css'
ReactDOM.render(
    <App />,
  document.getElementById('root')
);

serviceWorker.register();
